
<template>
  <div class="font app-content isVisitor bg-organization" >
    <b-container class='mt-4 px-0'>
      <b-row>
        <b-col cols='10' class='mx-auto'>
          <b-row v-show="isShowDetailDate">
            <a @click="initCalendar()" class='text-orange'>＜ カレンダーに戻る</a>
          </b-row>


          <b-row class='mt-4 border-bottom pb-2'>
            <b-col cols="8" class='px-0'>
              <h4 class="org_title">{{ user.first_name }} {{ user.middle_name }} {{ user.last_name }}の面接日程</h4>
            </b-col>
            <b-col cols='4' class='px-0 text-right'>
              <router-link class='text-orange'>
                <b-button pill class='bg-orange mx-2' size="sm">{{$t("message.edit2")}}</b-button>
              </router-link>
            </b-col>
          </b-row>
          <div>
            <b-row v-if="interviews.length > 0" class='mt-5 mb-5'>
              <b-col v-for="interview in interviews" cols='12' class='px-0' :key="interview.id">
                <b-card class="text-center">
                  <ul class="px-0 mb-0">
                    <li class="pb-2 news-li shortcut text-left d-flex justify-between">
                      <p class="px-4 m-auto">{{ dayFormat(interview.interview_date)}}</p>
                      <div class="row">
                        <b-img v-bind="mainProps" rounded="circle" alt="Circle image"></b-img>
                        <p class="contact-name mb-0 px-2">
                            {{ user.first_name }} {{ user.middle_name }} {{ user.last_name }}
                            <br/><span class="contact-description">{{ birth2age(user.birthday)}}/{{ getGender(user.gender) }}/{{ user.nationality }}</span>
                        </p>
                      </div>
                      <p class="px-4 m-auto">職種: [正] 建築・土木/リフォーム・内装/生産・品質</p>
                  
                      <b-button variant="outline-secondary" size="sm">
                        <router-link :to="'./mail-box?u_id=' + interview.id">チャットをみる</router-link>
                      </b-button>
                    </li>
                  </ul>
                </b-card>
              </b-col>
            </b-row>
            <b-row v-else>
                <h5 class="mx-auto pt-3 pb-3">面接の予定はありません</h5>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

import moment from 'moment';
import axios from 'axios';

export default {
  components: {
  },
  data() {
    return{
      idToken: localStorage.idToken,
      uId: this.$route.params.uid,
      mainProps: { blank: true, blankColor: '#777', width: 50, height: 50, class: 'm1' },
      interviews: [],
      user: {},
    }
  },
  methods: {
	dayFormat(d) {
      if(d != null) {
        var d1 = moment(d).add(1, 'hours')
        return moment(d).format("HH:mm") + "~" + d1.format("HH:mm")
      } else {
        return "00:00~01:00"
      }
    },
    birth2age(day) {
      if( day != null){
        var birth = moment(day);
        return moment().diff(birth, 'years') + "歳";
      }
      return ''
    },
    getGender(gender){
      if(gender == "man"){
        return "男性"
      }else if(gender == "woman"){
        return "女性"
      }else{
        return "その他"
      }
    },
    fetchInterviews: function() {
      return axios
        .get(process.env.VUE_APP_API + "/api/org/recruits/1/interviews?u_id=" + this.uId, {headers: {'Authorization': 'Bearer ' + this.idToken}})
    },
    fetch_user: function(u_id) {
      this.$store.commit('setLoading', true)
      return axios
        .get(process.env.VUE_APP_API + "/api/org/users/" + u_id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
    },
    initCalendar: function() {
      this.fetchInterviews()
            .then(response => {
              this.interviews = response.data.interviews
            })
      this.fetch_user(this.uId).then((res) => {
        this.user = res.data.user
      })
    }
  },
  mounted(){
    this.initCalendar()
    this.$store.commit('setLoading', false)
  }
}

</script>

<style scoped lang="scss">
</style>
